import { afterNextRender, Component, ElementRef, Input } from '@angular/core';
import { TaskTemplate } from '@modules/project/types/task-template';
import { RecordTask } from '@modules/records/types/record';
import { Mermaid } from 'mermaid'
import mermaid from 'mermaid';

@Component({
    selector: 'app-tasks-mermaid',
    templateUrl: './tasks-mermaid.component.html',
    styleUrl: './tasks-mermaid.component.less',
    standalone: false
})
export class TasksMermaidComponent {

  @Input() tasks?: TaskTemplate[] | RecordTask[] = [];
  @Input() diagram: string = '';

  constructor(private el: ElementRef) {
    // mermaid.initialize({ startOnLoad: false });
    afterNextRender({
      read: () => {
        void mermaid.init()
      }
    })
  }

  ngAfterViewInit(): void {
    this.renderMermaid();
  }

  ngOnChanges(): void {
    this.renderMermaid();
  }

  renderMermaid() {
    this.transformTasksToDiagram();
    // console.log('[TasksMermaidComponent][renderMermaid] ', this.diagram);
  }
  
  transformTasksToDiagram(): void {
    // Create a map for quick lookup by type
    const tasks = this.tasks || [];
    const typeMap = new Map<string, TaskTemplate>();
    tasks.forEach(node => {
      if (node.type) {
        typeMap.set(node.type, node);
      }
    });

    // Store edges as Mermaid lines
    const edges: Set<string> = new Set();
    const nodesWithEdges = new Set<string>();

    // Generate the edges
    tasks.forEach(node => {
      if (node.needs?.length === 0) return;
      if (node.needs) {
        node.needs.forEach(needType => {
          nodesWithEdges.add(node.type!);
          nodesWithEdges.add(needType);
          if (typeMap.has(needType)) {
            edges.add(`${needType} --> ${node.type}`);
          } else {
            // Optional: handle unknown dependencies
            edges.add(`${needType} -.-> ${node.type}`);
          }
      });
      }
    });

    // Add standalone nodes (not in any edge)
    const standaloneNodes = tasks
      .map(node => node.type)
      .filter(type => !nodesWithEdges.has(type!));

    // Generate Mermaid diagram string
    const mermaidDiagram = [
      `graph TD`,
      ...Array.from(edges).map(line => `  ${line}`), // nodes with edges
      ...standaloneNodes.map(type => `  ${type}`) // standalone nodes with no edges
    ].join('\n');

    this.diagram = mermaidDiagram;
  }

}
